class Tabs extends HTMLElement {
    constructor() {
        super();
        const tabTitles = this.querySelectorAll('.tab-title');
        tabTitles.forEach((tab) => {
            tab.addEventListener('pointerdown', (event) => { this.tabClick(event) })
        })
    }

    tabClick(event) {
        let currentTab = this.querySelector('.tab-title.active');
        let newTab = event.target.closest('.tab-title');
        let currentContent = this.querySelector('.tab-content__container.active');
        let newContent = this.querySelector(`.tab-content__container[data-tab="${newTab.getAttribute("data-tab")}"]`);
        newTab.classList.toggle('active');
        currentTab.classList.toggle('active');
        newContent.classList.toggle('active');
        currentContent.classList.toggle('active');
    }
}

customElements.define('custom-tabs', Tabs)

// for header categories button
const categoriesButton = document.querySelector('.categories-button');
const categoriesContainer = document.querySelector('.categories-container');
categoriesButton.addEventListener('click', () => {
    categoriesContainer.classList.toggle('active');
    document.body.addEventListener('click', (event) => {
        if (!categoriesContainer.contains(event.target) && !categoriesButton.contains(event.target)) {
            categoriesContainer.classList.remove('active');
        }
    })
})

let test = document.querySelector('.customer.account');
if (test) {
    // adds some custom styles to the Add a Pet form
    document.addEventListener('DOMContentLoaded', () => {
        const formContainer = document.querySelector('#app-embed');
        const observer = new MutationObserver((mutationsList, observer) => {
            const form = document.querySelector('form-embed');

            if (form) {
                observer.disconnect();
                const shadow = form.shadowRoot;

                const sheet = new CSSStyleSheet();
                sheet.insertRule(`
                h1, h2, h3, button[type="submit"] {
                    font-family: "le-havre", sans-serif !important;
                }
            `);
                sheet.insertRule(`
                #app-embed {
                    max-height: 30px !important;
                }
            `);
                sheet.insertRule(`
                #app-embed[data-current-step="success"] {
                    max-height: 75px !important;
                }
            `);
                sheet.insertRule(`
                ._formFieldContainer_1mxsl_5 {
                    display: none !important;
                }
            `);
                sheet.insertRule(`
                button[type="submit"] {
                outline: none !important;
                color: #11110D !important;
                border-radius: 5px !important;
                padding: 7px 20px !important;
                box-shadow: none!important;
                max-width: 250px !important;
                }
            `);

                shadow.adoptedStyleSheets.push(sheet);
                if (formContainer) {
                    formContainer.classList.add('loaded');
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });

    setTimeout(() => {
        // Get the form-embed element
        const formEmbed = document.querySelector('form-embed#app-embed');

        // Access the shadow root
        const shadowRoot = formEmbed.shadowRoot;

        // Now target the input fields
        const emailInput = shadowRoot.querySelector('#email');
        const requestInput = shadowRoot.querySelector('#custom\\#request'); // Note the escaped #

        // Update values
        if (emailInput) {
            emailInput.value = window.customerEmail;
            emailInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (requestInput) {
            requestInput.value = 'Order history request';
            requestInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }, 1500)
}

if (window.location.href.includes('/products')) {
    // adds some custom styles to the
    document.addEventListener('DOMContentLoaded', () => {
        const formContainer = document.querySelector('#app-embed');
        const observer = new MutationObserver((mutationsList, observer) => {
            const form = document.querySelector('form-embed');

            if (form) {
                observer.disconnect();
                const shadow = form.shadowRoot;

                const sheet = new CSSStyleSheet();
                sheet.insertRule(`
                h1, h2, h3, button[type="submit"] {
                    font-family: "le-havre", sans-serif !important;
                }
            `);
                sheet.insertRule(`
                #app-embed {
                    max-height: 30px !important;
                }
            `);
                sheet.insertRule(`
                #app-embed[data-current-step="success"] {
                    max-height: 75px !important;
                }
            `);
                sheet.insertRule(`
                ._formFieldContainer_1mxsl_5 {
                    display: none !important;
                }
            `);
                sheet.insertRule(`
                button[type="submit"] {
                    background-color: #fff;
                    border: 1px solid #31747E;
                    color: #121212;
                    border-radius: 1px;
                    padding: 4px 20px;
                    font-family: 'le-havre', sans-serif;
                    letter-spacing: 1px;
                    width: fit-content;
                }
            `);
                sheet.insertRule(`
                button[type="submit"]:hover {
                    box-shadow: 1px 1px 3px rgba(0,0,0,0.25);
                    border: 1px solid #31747E;
                }
            `);

                shadow.adoptedStyleSheets.push(sheet);
                if (formContainer) {
                    formContainer.classList.add('loaded');
                }
            }

            const formEmbed = document.querySelector('form-embed#app-embed');
            if (formEmbed) {
                const shadowRoot = formEmbed.shadowRoot;

                const emailInput = shadowRoot.querySelector('#email');
                const requestInput = shadowRoot.querySelector('#custom\\#request'); // Note the escaped #

                // Update values
                if (emailInput) {
                    emailInput.value = window.customerEmail;
                    emailInput.dispatchEvent(new Event('input', { bubbles: true }));
                }

                if (requestInput) {
                    requestInput.value = 'Request for permission to shop';
                    requestInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
}

let close = document.getElementById('close');
if (close) {
    close.addEventListener('pointerdown', (event) => {
        let jared = event.target.closest('.alert-banner');
        jared.style.display = "none";
    })
}

